<template>
    <div>
        <p v-text="label"></p>
        <p v-text="description"></p>
        <div v-if="seriousObservations.length">
            <p>Serious Observations:</p>
            <ul>
                <li v-for="seriousObservation in seriousObservations"
                    :key="seriousObservation.id">
                    <span v-if="seriousObservation.is_emergency">EMERGENCY - </span>
                    {{ seriousObservation.name }}
                    <span v-if="seriousObservation.name !== seriousObservation.common_name">
                        ({{ seriousObservation.common_name}})
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import {triage} from "../infermedica";
    export default {
        props: ['age', 'sex', 'evidence'],
        data: () => ({
            label: '',
            description: '',
            seriousObservations: [],
        }),
        created() {
            this.triage();
        },
        methods: {
            async triage() {
                this.$emit('loading');
                const {label, description, serious} = await triage(this.age, this.sex, this.evidence);
                this.label = label;
                this.description = description;
                this.seriousObservations = serious;
                this.$emit('doneLoading');
            }
        }
    };
</script>